export const SUPPORT_EMAIL = 'support-walden-fast@walden-group.com';
